export default __webpack_public_path__ + "defa9cd49c8baf4c87a23609a2e3c4f1.png";